import remark from 'remark'
import remarkHTML from 'remark-html'

export const markdownToHtml = 
  value => ({ __html: remark().use(remarkHTML).processSync(value).toString() })

